import de from '@/i18n/locales/de.json'
import fr from '@/i18n/locales/fr.json'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'de',
  fallbackLocale: 'de',
  messages: {
    de,
    fr,
  },
}))
